module.exports = __webpack_public_path__ + "static/media/MB-front-view.06ce9481.jpg";